import { Container, Box, Typography } from '@mui/material';
import Image from 'src/components/image';
import styles from '../styles/terms.module.css';

export default function Page() {
  return (
    <Container>
      <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Typography variant="h2" component="h1" sx={{ fontWeight: 'bold' }}>
          How to Become a Trainer
        </Typography>
      </Box>
      <div>Last Updated: 23 Dec 2024<br /><br />

        <h5><strong>1. Download our APP</strong></h5>
        Download Our App <strong>FitU SG</strong> from APP store. Make sure your app store region is Singapore,
        otherwise you cannot find it. You can find Apple Store and Google Play Store download links in the bottom of the
        website.<br /><br /><br />
        <h5><strong>2. Register</strong></h5>
        Register with SG phone number & email. You will receive a verification code to your phone number and email. Note
        that email is required to become a trainer.<br /><br /><br /><br /><br />
        <h5><strong>3. Create Trainer Profile</strong></h5>
        Go to <strong>Me</strong> -&gt; <strong>Register a trainer profile</strong>. Note that after you create 1 profile,
        "Register a trainer profile" button will disappear.<br /><br />
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <Image src="/assets/images/resources/become_trainer.jpg" alt="Become a Trainer"
            sx={{ maxWidth: { xs: '80%', md: '20%' }, height: 'auto' }} />
        </Box><br /><br /><br />
        <h5><strong>4. Fill in Your Details</strong></h5>
        <li>
          <strong>Upload Photo</strong>: Upload a clear and professional profile picture of yourself. Ensure your face
          is clearly visible. This will be the cover photo of your profile.
        </li>
        <li>
          <strong>Certificates</strong>: Select at least one of the certificates: ACE, ACSM, NCSF, ISSA, or Others.
          Upload a clear photo for each of your certificate selection.
        </li>
        <li>
          <strong>Gender</strong>: Select your gender. Note that this field can't be updated after the profile is
          created.
        </li>
        <li>
          <strong>Session Income</strong>: Select your income after you finish coaching each session.
        </li>
        <li>
          <strong>Years of Coaching Experience</strong>: Fill in the number of years of experience you have. Remember to
          update this field as you gain more experience.
        </li>
        <li>
          <strong>Languages</strong>: Select all the languages you can speak for coaching.
        </li>
        <li>
          <strong>Preferred Time and Region</strong>: Select the time and region you prefer to coach. You can have 1-3
          non-duplicated options.
        </li>
        <li>
          <strong>Expertise</strong>: Select 1 or 2 of your specialties.
        </li>
        <br /><br /><br />
        <h5><strong>5. Update</strong></h5>

        After you have filled in all the details, your profile will be available to view immediately.
        In <strong>Me</strong> page, you can click <strong>Edit</strong> button to update your profile,
        or <strong>Hide</strong> button so that clients cannot see your profile in the main page,
        if you currently cannot conduct training.<br /><br />
        <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', width: '100%' }}>
          <Image src="/assets/images/resources/update_profile.jpg" alt="update profile"
            sx={{ maxWidth: { xs: '80%', md: '20%' }, height: 'auto' }} />
        </Box><br /><br /><br />
      </div>
    </Container>
  );
}
